import React from 'react';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import ReactHtmlParser from 'react-html-parser';

import { transformSource } from '../../utils/helpers';

import type { SiteDescription$key } from './__generated__/SiteDescription.graphql';
import './SiteDescription.sass';

interface Props {
	descriptionData: SiteDescription$key | null;
}

function SiteDescription(props: Props) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const homeDescriptionData: any = useFragment(
		graphql`
			fragment SiteDescription on HomePublishedContent {
				shortDescriptionTitle
				shortDescriptionContent
			}
		`,
		props.descriptionData
	);

	const {
		shortDescriptionTitle,
		shortDescriptionContent,
	} = homeDescriptionData;
	return (
		<div className="site-description">
			<h2 className="uikit-heading-lg site-description__heading">
				{shortDescriptionTitle}
			</h2>
			{ReactHtmlParser(shortDescriptionContent, {
				transform: transformSource,
			})}
		</div>
	);
}

export default SiteDescription;
